import {
  DAY_LABEL,
  EFFECT_TYPES,
  EMAIL_TYPE_LABELS,
  EXAM_TYPE_LABEL,
  NON_COMMUNIQUE,
  PRESCRIPTION_WARNING_LABELS,
  SEXE_LABEL,
  STATUS_CONFIG,
  STATUS_REASON_LABELS,
  normalizeText,
} from "../../utils";

const PATH_LABELS = {
  status: "Statut",
  statusReason: "Motif",
  rejectReason: "Motif de refus",
  internalNumber: "N° de dossier",
  externalNumber: "N° externe",
  number: "N° de dossier",
  silReservationNumber: "N° de réservation",
  establishment: "Établissement",
  samplingDate: "Date de prélèvement",
  samplerCode: "Préleveur",
  laboratory: "Laboratoire",
  clinic: "Clinique",
  type: "Type",
  source: "Source",
  submittedAt: "Soumis le",
  checkInDate: "Arrivée au laboratoire",
  flags: "Alertes",
  comments: "Commentaires",
  "comments.text": "Commentaire",
  "entries.enabled": "Synchronisation active",
  "entries.schedule": "Planification",
  "entries.overlapMinutes": "Marge de recouvrement (min)",
  "entries.batchSize": "Taille des lots",
  customMessage: "Message personnalisé",
  selectedGuidelineIds: "Recommandations jointes",
  correspondants: "Correspondants",
  "correspondants.code": "Code correspondant",
  "correspondants.name": "Correspondant",
  additionalDoctors: "Médecins supplémentaires",
  prescriptions: "Ordonnances",
  questionRecords: "Questions",
  "questionRecords.answer": "Réponse",
  "questionRecords.forced": "Question forcée",
  guidelines: "Recommandations",
  "guidelines.validated": "Recommandation validée",
  "patient.firstName": "Prénom",
  "patient.lastName": "Nom",
  "patient.birthLastName": "Nom de naissance",
  "patient.birthdate": "Date de naissance",
  "patient.sexe": "Sexe",
  "patient.birthplace": "Lieu de naissance",
  "patient.birthplaceCode": "Code lieu de naissance",
  "patient.INS.value": "INS",
  "patient.INS.isQualified": "INS qualifiée",
  "patient.phone": "Téléphone",
  "patient.email": "Email",
  "patient.address": "Adresse",
  "patient.zipCode": "Code postal",
  "patient.city": "Ville",
  "patient.country": "Pays",
  "patient.room": "Chambre",
  "patient.IPP": "IPP",
  "patient.weight": "Poids",
  "patient.height": "Taille",
  "patient.hostService": "Service",
  "patient.admissionId": "N° d'admission SIL",
  "patient.externalId": "Identifiant patient SIL",
  "patient.silPatientNumber": "Identifiant patient SIL",
  "patient.patientId": "Patient lié",
  "patient.resultTransmissionMode": "Transmission des résultats",
  "patient.identityProofVerified": "Identité vérifiée",
  "patient.comments": "Commentaires patient",
  "patient.mutuelle.code": "Code mutuelle",
  "patient.mutuelle.name": "Mutuelle",
  "patient.mutuelle.adherentNumber": "N° d'adhérent",
  "patient.mutuelle.rightsFrom": "Droits mutuelle à partir du",
  "patient.mutuelle.rightsTo": "Droits mutuelle jusqu'au",
  "patient.mutuelle.manual": "Mutuelle saisie manuellement",
  acts: "Analyses",
  "acts.ALD": "ALD",
  "acts.text": "Libellé de l'analyse",
  "acts.idAnalyses": "Identifiants KaliSil des analyses",
  "acts.renewal.enabled": "Renouvellement",
  "acts.renewal.count": "Nombre de renouvellements",
  "acts.renewal.deadline": "Renouvellement jusqu'au",
  "acts.incompatibleWith": "Incompatible avec",
  "acts.examTypeOffset": "Position de l'en-tête de catégorie",
  date: "Date de l'ordonnance",
  keyRenewal: "Renouvellement d'origine",
  "hprim.externalId": "N° SIL",
  "hprim.silPrescriptionNumber": "N° SIL",
  "doctor.lastName": "Médecin",
  "doctor.firstName": "Médecin (prénom)",
  "doctor.RPPS": "RPPS",
  "doctor.ADELI": "ADELI",
  "doctor.code": "Code médecin",
  "doctor.city": "Médecin (ville)",
  "doctor.zipCode": "Médecin (code postal)",
  "doctor.address": "Médecin (adresse)",
  answer: "Réponse",
  forced: "Question forcée",
  question: "Énoncé",
  questionCode: "Code question",
  questionIds: "Questions",
  actionId: "Action",
  answerType: "Type de réponse",
  autoAnswer: "Réponse automatique",
  skipIfAlreadyAnswered: "Ne pas poser si déjà répondu",
  canAnswerInPreRegistration: "Réponse en pré-enregistrement",
  options: "Options",
  "options.label": "Libellé d'option",
  "options.code": "Code d'option",
  renditions: "Formulations par audience",
  optionLabels: "Libellés d'options",
  "optionLabels.optionId": "Option",
  "optionLabels.disabled": "Option désactivée",
  isRequired: "Obligatoire",
  patient: "Visible patient",
  patientQuestion: "Énoncé patient",
  patientIsRequired: "Obligatoire patient",
  ide: "Visible IDE",
  ideQuestion: "Énoncé IDE",
  ideIsRequired: "Obligatoire IDE",
  order: "Ordre",
  stage: "Étape",
  configStatus: "Statut de configuration",
  isDeleted: "Supprimé",
  deleted: "Supprimée",
  value: "Valeur",
  name: "Nom",
  codes: "Codes",
  exams: "Examens",
  EXAM_TYPE_PRIORITY: "Priorité des types d'analyse",
  "exams.value": "Examen",
  ubilabUrl: "URL Ubilab",
  relatedCodes: "Sous-codes associés",
  incompatibleCodes: "Codes incompatibles",
  sampleId: "Code échantillon",
  codeType: "Type de code",
  tubes: "Tubes à prélever",
  "tubes.quantity": "Nombre de tubes",
  "tubes.type": "Type de tube",
  enabledAtFrontDesk: "Disponible à la saisie",
  isVisible: "Visible",
  qrCodeToken: "Jeton QR code",
  botIds: "Machines",
  activeFields: "Champs visibles",
  activeFieldsOverrides: "Champs visibles du site",
  "patient.INS": "INS",
  "mutuelle.code": "Code mutuelle",
  "mutuelle.adherentNumber": "Numéro d'adhérent",
  "mutuelle.rightsFrom": "Droits du",
  "mutuelle.rightsTo": "Droits au",
  "prescription.doctor": "Médecin prescripteur",
  guideline: "Recommandation",
  secretary: "Audience secrétaire",
  secretaryGuideline: "Recommandation secrétaire",
  priority: "Priorité",
  patientGuideline: "Recommandation patient",
  ideGuideline: "Recommandation IDE",
  triggerGroups: "Conditions de déclenchement",
  "triggerGroups.operator": "Opérateur",
  "triggerGroups.triggers": "Déclencheurs",
  "triggerGroups.triggers.type": "Type de déclencheur",
  "triggerGroups.triggers.field": "Champ du déclencheur",
  "triggerGroups.triggers.values": "Valeurs du déclencheur",
  "triggerGroups.triggers.negate": "Déclencheur inversé",
  groupsOperator: "Opérateur des groupes",
  effects: "Effets",
  "effects.type": "Type d'effet",
  email: "Email",
  username: "Identifiant",
  group: "Groupe",
  mustChangePassword: "Changement de mot de passe requis",
  role: "Rôle",
  is_locked: "Compte verrouillé",
  hiddenExams: "Examens masqués",
  highlightAllExams: "Surligner tous les examens",
  filterConnectedPrescriptionAttachments: "Filtrer les pièces jointes des prescriptions connectées",
  firstName: "Prénom",
  lastName: "Nom",
  phone: "Téléphone",
  code: "Code",
  address: "Adresse",
  city: "Ville",
  zipCode: "Code postal",
  result: "Résultat",
  leaseLost: "Verrou perdu",
  externalId: "N° SIL",
  silAdmissionNumber: "N° dossier SIL",
  silPatientNumber: "Identifiant patient SIL",
  silRenewalId: "Renouvellement SIL",
  silPatientId: "Identifiant technique SIL",
  duration: "Durée",
  error: "Erreur",
  steps: "Étapes",
  machine: "Machine",
  screenshot: "Capture d'écran",
  source_: "Source",
  variant: "Variante",
  runId: "Exécution",
  stored: "Éléments reçus",
  key: "Entrée du plan",
  batch: "Lot",
  rows: "Lignes reçues",
  upserted: "Éléments ajoutés",
  modified: "Éléments modifiés",
  renewals: "Renouvellements",
  patientsModified: "Patients modifiés",
  created: "Réponses créées",
  matched: "Réponses déjà connues",
  patientNotFound: "Patients introuvables",
  dryRun: "Simulation",
  warnings: "Avertissements",
  field: "Champ",
  conflict: "Conflit",
  baseValue: "Valeur de référence",
  conflictSourceValue: "Valeur proposée par la source",
  mode: "Mode de déclenchement",
  sharedToNetwork: "Partagé au réseau",
  patientOptions: "Options patient",
  ideOptions: "Options IDE",
  anchorQuestionCode: "Position dans la liste",
  networkSourceId: "Élément du réseau",
  table: "Table",
  creates: "Éléments créés",
  updates: "Éléments mis à jour",
  restores: "Éléments restaurés",
  missingFromSource: "Éléments absents de la source",
  adoptions: "Éléments repris de la source",
  conflicts: "Conflits détectés",
  overridesAutoResolved: "Personnalisations résorbées",
  errors: "Erreurs",
  questionsCount: "Questions exportées",
  guidelinesCount: "Recommandations exportées",
  actionsCount: "Actions exportées",
  questionsImported: "Questions importées",
  guidelinesImported: "Recommandations importées",
  actionsImported: "Actions importées",
};

const INFO_FIELD_LABELS = {
  SEXE: "Sexe",
  INS: "Statut INS",
  MUTUELLE: "Statut mutuelle",
  PRESCRIPTION: "Ordonnance",
  EXAM: "Examens détectés",
  PRESCRIPTION_WARNING: "Alerte sur l'ordonnance",
  PATIENT_STATUS: "Statut patient",
  TYPE: "Type d'admission",
};

const INFO_VALUE_LABELS = {
  SEXE: SEXE_LABEL,
  INS: { QUALIFIED: "Qualifié", NON_QUALIFIED: "Non qualifié" },
  MUTUELLE: { UP_TO_DATE: "À jour", OUTDATED: "Périmée", UNKNOWN: "Non renseignée" },
  PRESCRIPTION: { PRESENT: "Présente", ABSENT: "Absente" },
  EXAM: { DETECTED: "Examen détecté sur au moins une ordonnance", NOT_DETECTED: "Au moins une ordonnance sans examen détecté" },
  PRESCRIPTION_WARNING: PRESCRIPTION_WARNING_LABELS,
  PATIENT_STATUS: { KNOWN: "Patient connu", UNKNOWN: "Nouveau patient" },
  TYPE: { NOW: "Au laboratoire", LATER: "Au domicile" },
};

const FLAG_LABELS = {
  PATIENT_INFO_ALREADY_EXISTS: "Patient déjà existant",
  PATIENT_NAME_MISSING_IN_PRESCRIPTION: "Nom patient manquant",
  NOT_ELIGIBLE: "Non éligible",
  DUPLICATE: "Doublon",
};

const ADMISSION_SOURCE_LABELS = { PATIENT: "le patient", IDE: "l'IDE" };
const COUNT_OPERATOR_LABELS = { ">=": "Au moins", "==": "Exactement", "<=": "Au plus" };
const DELTA_FIELD_LABELS = { DATE: "de date", HOUR: "d'heure", DATETIME: "de date et heure" };
const DELTA_UNIT_LABELS = { MINUTES: "min", HOURS: "h", DAYS: "j" };

const shortId = (value) => `#${String(value).slice(-6)}`;

const describeDelta = (field, values) => {
  const isDateTime = field === "DATETIME";
  const operator = (isDateTime ? values[4] : values[2]) || ">=";
  const threshold = (isDateTime ? values[5] : values[3]) || "?";
  const unit = isDateTime ? DELTA_UNIT_LABELS[values[6]] || "min" : field === "DATE" ? "j" : "min";
  return `Écart ${DELTA_FIELD_LABELS[field] || field} ${operator} ${threshold} ${unit}`;
};

const isReference = (value) => /^[0-9a-f]{24}$/.test(String(value));

const describeTrigger = ({ type, field, values = [], negate, fieldLabel, valueLabels }) => {
  // Une référence dont le libellé n'a pas pu être figé (option ou laboratoire supprimé depuis)
  // s'annonce comme telle plutôt que d'afficher un identifiant nu.
  const shown = values
    .map((value, index) => valueLabels?.[index] ?? (isReference(value) ? `référence ${shortId(value)}` : value))
    .filter((value) => value !== "" && value !== null && value !== undefined);
  const list = (labels) => shown.map((value) => labels?.[value] || value).join(", ") || "—";
  const condition = () => {
    if (type === "ALWAYS") return "Dans tous les cas";
    if (type === "CODE_SOME") return `Au moins un code parmi ${list()}`;
    if (type === "CODE_EVERY") return `Tous les codes ${list()}`;
    if (type === "EXAM_TYPE_SOME") return `Au moins un type d'analyse parmi ${list(EXAM_TYPE_LABEL)}`;
    if (type === "EXAM_TYPE_EVERY") return `Tous les types d'analyse ${list(EXAM_TYPE_LABEL)}`;
    if (type === "MUTUELLE_CODE") return `Code mutuelle parmi ${list()}`;
    if (type === "LABORATORY") return `Laboratoire parmi ${list()}`;
    if (type === "FLAG") return `Alerte ${list(FLAG_LABELS)}`;
    if (type === "STATUS") return `Statut du dossier parmi ${list(Object.fromEntries(Object.entries(STATUS_CONFIG).map(([key, config]) => [key, config.label])))}`;
    if (type === "SOURCE") return `Dossier créé par ${list(ADMISSION_SOURCE_LABELS)}`;
    if (type === "QUESTION" && !fieldLabel) return `Réponse à une question (référence ${field ? shortId(field) : "—"})`;
    if (type === "QUESTION") return `Réponse « ${list()} » à la question « ${fieldLabel} »`;
    if (type === "ADMISSION_COUNT") return `${COUNT_OPERATOR_LABELS[values[0]] || values[0]} ${values[1] || "?"} admissions le même jour`;
    if (type === "DELTA") return describeDelta(field, values);
    if (type === "INFO" && field === "AGE") return `Âge de ${values[0] || "0"} à ${values[1] || "?"} ans`;
    if (type === "INFO" && field === "HOUR") return `Soumission entre ${values[0] || "?"} et ${values[1] || "?"}`;
    if (type === "INFO" && field === "DAY") return `Soumission le ${list(DAY_LABEL)}`;
    if (type === "INFO") return `${INFO_FIELD_LABELS[field] || field} : ${list(INFO_VALUE_LABELS[field])}`;
    return `${type}${field ? ` ${field}` : ""} : ${list()}`;
  };
  return negate ? `Exclut : ${condition()}` : condition();
};

// Renvoie null pour tout ce qui n'est pas un groupe : les événements d'avant l'enregistrement
// des groupes entiers ne stockaient qu'un marqueur positionnel, qu'il ne faut pas traduire.
const describeTriggerGroup = (group) => {
  if (!group || typeof group !== "object" || !Array.isArray(group.triggers)) return null;
  return group.triggers.map(describeTrigger).join(group.operator === "OR" ? " OU " : " ET ") || "Aucune condition";
};

const ACTION_PHRASES = {
  LOGIN: "s'est connecté",
  LOGIN_FAILED: "a échoué à se connecter",
  LOGIN_LOCKED: "a vu son compte verrouillé",
  PASSWORD_RESET_REQUEST: "a demandé une réinitialisation de mot de passe",
  PASSWORD_RESET: "a réinitialisé son mot de passe",
  PASSWORD_SET: "a défini un nouveau mot de passe",
  PASSWORD_CHANGED: "a changé son mot de passe",
  OTP_SENT_SMS: "a reçu un code de connexion par SMS",
  OTP_SENT_EMAIL: "a reçu un code de connexion par email",
  OTP_DISABLED: "a désactivé le code de connexion",
  EXPORT_CONFIG: "a exporté la configuration",
  IMPORT_CONFIG: "a importé une configuration",
  REORDER: "a réordonné les éléments",
  SYNC: "a synchronisé le référentiel",
  SYNC_INGEST: "a reçu une synchronisation",
  SYNC_RECONCILE: "a appliqué une synchronisation",
  SYNC_CONFLICT_RESOLVED: "a ignoré une modification de la source et conservé sa valeur",
  SYNC_OVERRIDE_REMOVED: "a appliqué la valeur de la source",
  SYNC_RUN_REQUESTED: "a demandé une synchronisation",
  SYNC_RUN_FAILED: "a signalé un échec de synchronisation",
  SYNC_CURSOR_RESET: "a relancé une synchronisation complète",
  PROCESSING: "a traité le dossier dans le SIL",
  ACTIONS_APPLIED: "a appliqué des actions sur les analyses",
};

const PROCESSING_STEP_LABELS = {
  INIT: "Initialisation",
  LOGIN: "Connexion",
  LABORATORY_SELECTION: "Sélection du laboratoire",
  LABORATORY_SELECTED: "Sélection du laboratoire",
  PATIENT_SELECTION: "Sélection du patient",
  PATIENT_CREATION: "Création du patient",
  IPP_INSERTION: "Insertion de l'IPP",
  ROOM_INSERTION: "Insertion de la chambre",
  MUTUELLE_SELECTION: "Sélection de la mutuelle",
  ADRI_CALL: "Appel ADRI",
  PRESCRIPTION_DATE_INSERTION: "Insertion de la date d'ordonnance",
  RENEWAL_PRESCRIPTION_INSERTION: "Insertion de l'ordonnance renouvelée",
  PRESCRIPTION_ANALYSIS_INSERTION: "Insertion des analyses",
  PRESCRIPTION_ALD_INSERTION: "Insertion de l'ALD",
  PRESCRIPTION_RENEWAL_INSERTION: "Insertion du renouvellement d'ordonnance",
  PRESCRIPTION_DOCTOR_INSERTION: "Insertion du médecin prescripteur",
  CORRESPONDANT_INSERTION: "Insertion du correspondant",
  ADDITIONAL_DOCTOR_INSERTION: "Insertion des médecins",
  SAMPLER_INSERTION: "Insertion du préleveur",
  SAMPLING_DATE_INSERTION: "Insertion de la date de prélèvement",
  ADMISSION_CREATED: "Dossier créé",
  ADMISSION_ID_INSERTION: "Insertion du n° d'admission",
  QUESTIONS_ANSWERING: "Réponse aux questions",
  FILES_INSERTION: "Insertion des fichiers",
  ADMISSION_COMPLETED: "Dossier complet",
};

const keysWithLabelMatching = (labels, needle) => Object.keys(labels).filter((key) => normalizeText(labels[key]).includes(needle));

const auditSearchParams = (q) => {
  const needle = normalizeText(q);
  if (!needle) return {};
  const paths = keysWithLabelMatching(PATH_LABELS, needle);
  // Les conditions étaient diffées champ par champ avant d'être enregistrées en groupes entiers.
  if (paths.some((path) => path.startsWith("triggerGroups"))) paths.push("triggerGroups", "triggerGroups.triggers.values");
  const values = [
    ...keysWithLabelMatching(Object.fromEntries(Object.entries(STATUS_CONFIG).map(([status, config]) => [status, config.label])), needle),
    ...keysWithLabelMatching(STATUS_REASON_LABELS, needle),
    ...keysWithLabelMatching(SEXE_LABEL, needle),
    ...keysWithLabelMatching(EMAIL_TYPE_LABELS, needle),
    ...keysWithLabelMatching(FLAG_LABELS, needle),
    ...keysWithLabelMatching(DAY_LABEL, needle),
    ...keysWithLabelMatching(EXAM_TYPE_LABEL, needle),
    ...keysWithLabelMatching(ADMISSION_SOURCE_LABELS, needle),
    ...keysWithLabelMatching(Object.assign({}, ...Object.values(INFO_VALUE_LABELS)), needle),
    ...keysWithLabelMatching(Object.fromEntries(EFFECT_TYPES.map((effect) => [effect.value, effect.label])), needle),
    ...keysWithLabelMatching({ [NON_COMMUNIQUE]: "Non communiqué", true: "Oui", false: "Non" }, needle),
  ].filter((value, index, all) => all.indexOf(value) === index);
  const actions = keysWithLabelMatching(ACTION_PHRASES, needle);
  return {
    ...(paths.length > 0 && { paths: paths.join(",") }),
    ...(values.length > 0 && { values: values.join(",") }),
    ...(actions.length > 0 && { actions: actions.join(",") }),
  };
};

export { PATH_LABELS, ACTION_PHRASES, PROCESSING_STEP_LABELS, FLAG_LABELS, auditSearchParams, describeTriggerGroup };
